import styled from '@emotion/styled';
import { createContext, useContext } from 'react';
import type { AnyObject, ObjectSchema } from 'yup';

const FormContext = createContext<{
  validations?: ObjectSchema<AnyObject>;
  triggerValidation?: number;
}>({});

type FormProps = {
  children: React.ReactNode;
  validations?: ObjectSchema<AnyObject>;
  triggerValidation?: number;
  width?: string;
};

export const Form = ({ children, validations, triggerValidation, width = '800px' }: FormProps) => {
  return (
    <Container width={width}>
      <FormContext.Provider value={{ validations, triggerValidation }}>
        {children}
      </FormContext.Provider>
    </Container>
  );
};

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (context === null) {
    throw new Error('useFormContext must be used within a FormProvider');
  }
  return context;
};

const Container = styled.div<{ width: string }>`
  width: ${p => p.width};
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;
